<ion-header [translucent]="true">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button [text]="'ZURUECK' | translate"></ion-back-button>
    </ion-buttons>
    <ion-title>{{ 'SCAN_UND_UPLOAD' | translate }}</ion-title>
    <ion-buttons slot="end">
      <ion-menu-button></ion-menu-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  <div class="padding-16 flex flex-column gap-16">

    <!-- Fotos-Vorschau -->
    @if (capturedPhotos().length > 0) {
      <div class="photo-grid">
        @for (photo of capturedPhotos(); track photo.fileName; let i = $index) {
          <div class="photo-item">
            <img [src]="photo.dataUrl" [alt]="photo.fileName" class="photo-preview" />
            <work-ui-button
              (buttonClick)="removePhoto(i)"
              [iconOnly]="true"
              iconName="close"
              size="small"
              variant="secondary"
              class="photo-remove-btn" />
          </div>
        }
      </div>
    }

    <!-- Foto aufnehmen / Gallerie -->
    <div class="flex gap-8">
      <work-ui-button
        (buttonClick)="takePhoto()"
        [disabled]="uploadLoadingState() === 'loading'"
        [fullWidth]="true"
        iconName="photo_camera"
        text="FOTO_AUFNEHMEN"
        variant="secondary"
        class="flex-1" />
      <work-ui-button
        (buttonClick)="pickFromGallery()"
        [disabled]="uploadLoadingState() === 'loading'"
        [fullWidth]="true"
        iconName="photo_library"
        text="GALLERIE"
        variant="secondary"
        class="flex-1" />
    </div>

    <!-- Notiz -->
    <div class="flex flex-wrap gap-8">
      @for (suggestion of noteSuggestions; track suggestion) {
        <work-ui-button
          (buttonClick)="applyNoteSuggestion(suggestion)"
          [text]="suggestion"
          size="small"
          variant="secondary" />
      }
    </div>
    <work-ui-input-field
      [formControl]="noteControl"
      label="NOTIZ"
      variant="textarea" />

    <!-- Senden -->
    <work-ui-button
      (buttonClick)="uploadAndSend()"
      [disabled]="capturedPhotos().length === 0"
      [(loadingState)]="uploadLoadingState"
      [fullWidth]="true"
      iconName="send"
      text="SENDEN"
      variant="primary" />

  </div>
</ion-content>
